import { useState } from 'react';

const faqs = [
  {
    q: '皮皮漫画网的漫画资源都是免费的吗？',
    a: '皮皮漫画网提供大量免费漫画资源供读者畅读，部分独家内容和最新连载需要会员订阅。我们通过合理的付费模式支持创作者，确保漫画内容持续更新。',
  },
  {
    q: '韩漫、日漫和国漫的更新频率是怎样的？',
    a: '热门韩漫和日漫通常保持每周更新，部分热门作品可实现日更。国漫连载根据作者排期，一般为每周或每两周更新一次。所有更新时间表都会在作品页面明确标注，方便读者追更。',
  },
  {
    q: '支持哪些设备阅读？有APP吗？',
    a: '皮皮漫画网支持PC浏览器、平板和手机浏览器访问。同时提供iOS和Android APP下载，APP支持离线缓存、夜间模式、更新推送等专属功能，阅读体验更佳。',
  },
  {
    q: '下拉阅读模式和其他阅读模式有什么区别？',
    a: '下拉阅读模式专为竖屏漫画（尤其是韩漫）设计，无需翻页，只需向下滑动即可连续阅读，阅读流畅度和沉浸感显著提升。同时我们也支持传统的左右翻页模式，可以在设置中自由切换。',
  },
  {
    q: '如何找到适合自己的漫画？',
    a: '你可以通过首页的漫画分类导航按品类筛选，查看排行榜了解热门作品，也可以在热门话题中看看大家都在讨论什么。编辑精选专栏还会定期推荐冷门佳作和新作品。',
  },
  {
    q: '想投稿或者合作应该怎么联系？',
    a: '欢迎漫画作者、翻译组和商务伙伴联系我们！你可以在联系我们板块找到邮箱和微信联系方式，也可以直接填写合作咨询表单，我们的团队会在1-2个工作日内回复。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <section id="faq" className="py-14 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="font-heading text-xl md:text-3xl text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">快速了解皮皮漫画的使用方式</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => toggle(i)}
                className="w-full px-5 md:px-6 py-4 flex items-center justify-between gap-3 text-left cursor-pointer"
              >
                <h3 className="font-heading text-base text-foreground-900 flex-1">
                  {faq.q}
                </h3>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500 text-lg"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === i ? 'max-h-96 pb-5 px-5 md:px-6' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}